import React from "react";

/* ─────────────────────────────────────────────────
   Reusable button primitives
───────────────────────────────────────────────── */

export const BtnPrimary = ({ children, onClick, full, small, className = "" }) => (
  <button
    onClick={onClick}
    className={`
      shimmer-btn inline-flex items-center gap-2 font-head font-semibold
      text-white rounded-xl cursor-pointer border-none outline-none
      transition-all duration-200
      hover:-translate-y-0.5 active:translate-y-0
      shadow-[0_6px_20px_rgba(30,86,217,.35)]
      hover:shadow-[0_10px_30px_rgba(30,86,217,.45)]
      ${small ? "text-sm px-5 py-2.5" : "text-base px-7 py-3.5"}
      ${full  ? "w-full justify-center" : ""}
      ${className}
    `}
  >
    {children}
  </button>
);

export const BtnOrange = ({ children, onClick, full, small, className = "" }) => (
  <button
    onClick={onClick}
    className={`
      inline-flex items-center gap-2 bg-orange-500 text-white font-head font-semibold
      rounded-xl cursor-pointer border-none transition-all duration-200
      shadow-[0_6px_20px_rgba(245,124,0,.3)]
      hover:bg-orange-400 hover:-translate-y-0.5
      hover:shadow-[0_10px_30px_rgba(245,124,0,.4)]
      ${small ? "text-sm px-5 py-2.5" : "text-base px-7 py-3.5"}
      ${full  ? "w-full justify-center" : ""}
      ${className}
    `}
  >
    {children}
  </button>
);

export const BtnOutline = ({ children, onClick, full, className = "" }) => (
  <button
    onClick={onClick}
    className={`
      inline-flex items-center gap-2 font-head font-semibold text-white
      border-2 border-white/40 rounded-xl px-7 py-3.5 cursor-pointer
      bg-transparent transition-all duration-200
      hover:border-white hover:bg-white/10 hover:-translate-y-0.5
      ${full ? "w-full justify-center" : ""}
      ${className}
    `}
  >
    {children}
  </button>
);

export const BtnWhite = ({ children, onClick, className = "" }) => (
  <button
    onClick={onClick}
    className={`
      inline-flex items-center gap-2 bg-white text-blue-700
      font-head font-bold text-base px-7 py-3.5 rounded-xl cursor-pointer
      border-none transition-all duration-200
      shadow-[0_6px_20px_rgba(0,0,0,.15)]
      hover:-translate-y-0.5 hover:shadow-[0_10px_30px_rgba(0,0,0,.2)]
      ${className}
    `}
  >
    {children}
  </button>
);

export const BtnBlue = ({ children, onClick, full, small, className = "" }) => (
  <button
    onClick={onClick}
    className={`
      inline-flex items-center gap-2 bg-blue-600 text-white font-head font-semibold
      rounded-xl cursor-pointer border-none transition-all duration-200
      shadow-[0_4px_15px_rgba(30,86,217,.3)]
      hover:bg-blue-500 hover:-translate-y-0.5
      ${small ? "text-sm px-5 py-2.5" : "text-base px-7 py-3.5"}
      ${full  ? "w-full justify-center" : ""}
      ${className}
    `}
  >
    {children}
  </button>
);
